import normalizeJsonApi from '../../shared/utilities/jsonApiNormalizer';

import { formatDateTime } from '../../shared/utilities/date';
import { DossierId } from '../dossier/types';

import {
    InTripReviewsJSONAPIResponse,
    NormalizedInTripReview,
    InTripReviewFromAPI,
    InTripReview,
} from './types';

export const inTripReviewSerializer = (inTripReview: InTripReviewFromAPI): InTripReview => {
    const createdAt = formatDateTime(inTripReview.attributes.createdAt);
    const isValidDate = createdAt && !isNaN(createdAt.getTime());
    const review = inTripReview.attributes.travellerReview
        ? inTripReview.attributes.travellerReview
        : null;

    return {
        ...inTripReview.attributes,
        travellerReview: review,
        createdAt: isValidDate ? createdAt : null,
    };
};

export function serializeInTripReviewsFromAPI(
    json: InTripReviewsJSONAPIResponse,
): NormalizedInTripReview {
    const { inTripReview } = normalizeJsonApi<{
        [dossierId: DossierId]: InTripReviewFromAPI;
    }>(json);

    const inTripReviewNormalized: NormalizedInTripReview = {};

    if (!inTripReview) {
        return {};
    }

    Object.entries(inTripReview).forEach(
        ([dossierId, inTripReview]: [DossierId, InTripReviewFromAPI]) =>
            (inTripReviewNormalized[dossierId] = inTripReviewSerializer(inTripReview)),
    );

    return inTripReviewNormalized;
}
